define("shared/modifiers/perfect-scroll", ["exports", "ember-modifier", "@ember/service", "@ember/debug", "perfect-scrollbar"], function (_exports, _emberModifier, _service, _debug, _perfectScrollbar) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-modifier",0,"@ember/service",0,"@ember/debug",0,"perfect-scrollbar"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  /**
   *
   * @class PerfectScrollModifier
   * @extends Modifier
   *
   * This handles initializing and destroying a Perfect Scrollbar instance
   * on the target element.
   *
   * Positional Parameters:
   * @param {String} id An identifier for keeping track of multiple scrollbars
   *
   * Named Parameters:
   * @param {Any} updateTrigger A value that will trigger re-initialization of the scrollbar on change.
   * @param {PerfectScrollbarOptions} <Multiple Names> See https://github.com/mdbootstrap/perfect-scrollbar#options for all other options.
   *
   * Examples:
   *
   * Simple Usage:
   *
   * Instantiates a Perfect Scrollbar on `div` and removes it when the `div` is destroyed.
   * ```
   * <div {{perfect-scroll}}>
   * ```
   *
   * Using an ID:
   *
   * Instantiates a Perfect Scrollbar on `div` and stores it with the given ID.
   * When `isRunning` is toggled, only the Perfect Scrollbar with "id-2" will be destroyed.
   * ```
   * <div {{perfect-scroll "id-1"}}></div>
   *
   * {{#if this.isRunning}}
   *   <div {{perfect-scroll "id-2"}}></div>
   * {{/if}}
   * ```
   *
   * Using `updateTrigger`:
   *
   * Updates the Perfect Scrollbar instance whenever `isRunning` changes.
   * Useful for when an element's contents are populated after initial render.
   * ```
   * <div {{perfect-scroll updateTrigger=this.isRunning}}>
   * ```
   *
   * Using Perfect Scrollbar Options:
   *
   * Creates a Perfect Scrollbar instance with specific Perfect Scrollbar Options applied.
   * ```
   * <div {{perfect-scroll
   *  wheelPropagation=true
   *  suppressScrollX=true
   *  scrollYMarginOffset=-1
   *  maxScrollbarLength=150}}
   * >
   * ```
   *
   * Using all possible options:
   *
   * Creates a configured Perfect Scrollbar instance where the
   * provided ID is used to keep track of this Perfect Scrollbar
   * instance, and is updated whenever `isRunning` changes.
   * ```
   * <div {{perfect-scroll
   *  this.id
   *  updateTrigger=this.isRunning
   *  wheelPropagation=true
   *  suppressScrollX=true
   *  scrollYMarginOffset=-1
   *  maxScrollbarLength=150}}
   * >
   * ```
   */
  let PerfectScrollModifier = (_dec = (0, _service.inject)(), (_class = class PerfectScrollModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "perfectScroll", _descriptor, this);

      _defineProperty(this, "scrollbar", null);
    }

    /**
     * @method id
     *
     * @returns {String|Number} Scrollbar ID
     */
    get id() {
      return this.args.positional[0];
    }
    /**
     * Returns the provided named arguments.
     * Removes the updateTrigger named argument, if provided,
     * as it's not a valid Perfect Scrollbar option.
     *
     * @method scrollOptions
     *
     * @returns {Object} Scrollbar Options Hash
     * See https://github.com/mdbootstrap/perfect-scrollbar#options
     */


    get scrollOptions() {
      const perfectScrollOptions = { ...this.args.named
      };
      delete perfectScrollOptions.updateTrigger;
      return perfectScrollOptions;
    }
    /**
     * When modifier is initialized or updated, create a new
     * PerfectScrollbar instance and save instance to service
     * cache (if it exists)
     *
     * @method didReceiveArguments
     */


    didReceiveArguments() {
      (false && !(this.perfectScroll) && (0, _debug.assert)('If you are inside an engine, inject the perfect-scroll service into that engine', this.perfectScroll));
      this.scrollbar = new _perfectScrollbar.default(this.element, this.scrollOptions);

      if (this.id) {
        this.perfectScroll.saveScrollbarToCache(this.id, this.scrollbar);
      }
    }
    /**
     * When modifier is to be removed, destroy scrollbar
     * instance and remove scrollbar from service cache (if it exists)
     *
     * @method didReceiveArguments
     */


    willRemove() {
      this.scrollbar.destroy(this.element);

      if (this.id) {
        this.perfectScroll.removeScrollbarFromCache(this.id);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "perfectScroll", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  _exports.default = PerfectScrollModifier;
});